import React, { Component, PropTypes } from 'react';
import AssetUploader from '../widgets/AssetUploader';
import AssetBrowser from '../widgets/AssetBrowser';
import { videoExtensions } from '../../constants/index';
import { CATEGORIES } from '../../services/fileUpload/uploadFile';

class PagesVideos extends Component {
    onResetErrors = () => {
        this.browser && this.browser.resetErrors();
    };

    onRefresh = () => {
        this.browser && this.browser.refresh();
    };

    render() {
        return (
            <div className="ThemeCalendar Theme-Content">
                <h1>Videos</h1>
                <hr />
                {this.props.children}
                <AssetBrowser
                    setRef={node => (this.browser = node)}
                    category={CATEGORIES.VIDEO}
                    filter={videoExtensions}
                    displayMode="grid"
                >
                    <div className="col-xs-1">
                        <AssetUploader
                            filter={videoExtensions}
                            onError={error => this.browser && this.browser.errorHandler(error)}
                            onResetErrors={this.onResetErrors}
                            onRefresh={this.onRefresh}
                            onOpen={this.onResetErrors}
                            metadata={{
                                category: CATEGORIES.VIDEO
                            }}
                        />
                    </div>
                </AssetBrowser>
            </div>
        );
    }
}

PagesVideos.propTypes = {
    children: PropTypes.element
};

export default PagesVideos;



// WEBPACK FOOTER //
// ./src/components/assets/PagesVideos.js